export const createStandardQuery = ({ setting, organizationId }) => {
  let query = `orgId=${organizationId}&startDate=${setting.startDate}&endDate=${setting.endDate}`
  const repositories = setting.selectedRepositories.map((repo) => repo.fullName).join(',')
  query += `&repositories=${repositories}`
  const teams = setting.selectedTeams.map((team) => team.slug).join(',')
  query += `&teams=${teams}`
  return query
}
